import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Reusable progress bar component for Academy
 * Shows course/quiz completion progress
 *
 * Usage:
 * <ut-academy-progress-bar
 *   [current]="3"
 *   [total]="5"
 *   [showPercentage]="true">
 * </ut-academy-progress-bar>
 */
@Component({
  selector: 'ut-academy-progress-bar',
  templateUrl: './academy-progress-bar.component.html',
  styleUrls: ['./academy-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AcademyProgressBarComponent {
  @Input() current: number = 0;
  @Input() total: number = 100;
  @Input() showPercentage: boolean = true;
  @Input() showLabel: boolean = true;
  @Input() labelSuffix: string = '';
  @Input() height: 'small' | 'medium' | 'large' = 'medium';
  @Input() color: 'primary' | 'success' | 'warning' = 'primary';

  get percentage(): number {
    if (this.total === 0) return 0;
    return Math.round((this.current / this.total) * 100);
  }

  get label(): string {
    const baseLabel = `${this.current}/${this.total}`;
    return this.labelSuffix ? `${baseLabel} ${this.labelSuffix}` : baseLabel;
  }

  get progressClass(): string {
    return `progress-${this.height} progress-${this.color}`;
  }
}
